import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../../../authentication/services/user.service';
import { WidgetModel } from '../../models/widget.model';
import { trans } from '../../../localization';
import { ListWidgetOptions } from '../../interfaces/list-widget-options.interface';
import { ActiveWidget } from '../../classes/active-widget';
import { LoaderService } from '../../../support/loading/loader.service';
import { ToastService } from '../../../toast/services/toast.service';

@Component({
    selector: 'chassis-core-user-list-widget',
    templateUrl: './user-list-widget.component.html',
    styleUrls: ['./user-list-widget.component.scss']
})
export class UserListWidgetComponent implements OnInit {

    @Input() public options: ListWidgetOptions;

    @Input() public users;

    @Input() widget: WidgetModel;

    public loader;

    constructor(protected widgetRef: ActiveWidget, protected userService: UserService, protected loaderService: LoaderService, protected toastService: ToastService) {
        this.userService.disableCache();

        this.loader = this.loaderService
            .create();
    }

    ngOnInit() {
        this.options = {
            title: trans('Users'),
            header: true,
            columns: [{
                name: 'name',
                title: trans('Name')
            }, {
                name: 'email',
                title: trans('Email')
            }]
        };

        this.init();
    }

    protected init() {
        this.load();

        // this.setRefreshInterval();
        this.setRefreshCallback();
    }

    protected setRefreshCallback() {
        this.widgetRef.setRefresh(() => {
            this.load();
        });
    }

    protected setRefreshInterval() {
        setInterval(() => {
            this.load();
        }, 10 * 1000);
    }

    protected load() {
        this.loader.start();

        const request = this.userService.all();

        request.subscribe((users) => {
            this.users = users;

            this.loader.stop();
        }, () => {
            this.loader.stop();

            this.toastService.error('error-api');
        });
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/dashboards/components/user-list-widget/user-list-widget.component.ts